var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "searchPanel" }, [
    _vm.showPesquisaLote && _vm.isBa && _vm.caixa === "ASSINATURA_CONJUNTA"
      ? _c("div", { staticClass: "loteSearch" }, [
          _c(
            "div",
            { staticClass: "row" },
            [
              _c("span", { on: { click: _vm.exibirBuscaPorLote } }),
              _c("a", { staticClass: "busca" }, [_vm._v("Pesquisa por lote")]),
              _c(
                "el-tooltip",
                { attrs: { effect: "dark", placement: "top-end" } },
                [
                  _c("i", { staticClass: "el-icon-info icon-info" }),
                  _c("template", { slot: "content" }, [
                    _vm._v(
                      "Para realizar a pesquisa de mais de um processo, insira a planilha contendo os números dos processos a serem pesquisados de acordo com o modelo a seguir. "
                    ),
                    _c(
                      "a",
                      {
                        staticClass: "btn-download",
                        on: { click: _vm.baixarModelo }
                      },
                      [_vm._v("(Baixar modelo)")]
                    )
                  ])
                ],
                2
              )
            ],
            1
          ),
          _c(
            "div",
            [
              _c("app-upload-area", {
                attrs: {
                  id: "lote",
                  target: "publico/upload",
                  fileType: _vm.validExtensions,
                  onSuccess: _vm.onSuccess,
                  documento: _vm.file,
                  hasDownloadButton: false
                },
                on: { removerDocumento: _vm.removerDocumento },
                model: {
                  value: _vm.file,
                  callback: function($$v) {
                    _vm.file = $$v
                  },
                  expression: "file"
                }
              }),
              _c(
                "div",
                { staticClass: "right-buttons" },
                [
                  _vm.showPesquisaLote
                    ? _c(
                        "el-button",
                        {
                          staticClass: "no-padding",
                          attrs: { type: "text" },
                          on: { click: _vm.voltar }
                        },
                        [_vm._v("Voltar")]
                      )
                    : _vm._e()
                ],
                1
              ),
              _c(
                "el-row",
                { staticClass: "button-row" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.consultar }
                    },
                    [
                      _c("i", { staticClass: "icon fa fa-search" }),
                      _vm._v("Pesquisar")
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        ])
      : _vm._e(),
    _vm.filtro.simples && !_vm.showPesquisaLote
      ? _c("div", { key: "simpleSearch", staticClass: "simpleSearch" }, [
          _c(
            "form",
            {
              on: {
                submit: function($event) {
                  $event.preventDefault()
                  return _vm.$emit("pesquisar", _vm.filtro)
                }
              }
            },
            [
              _c(
                "el-input",
                {
                  staticClass: "input input-with-select",
                  attrs: {
                    placeholder: _vm.placeholder,
                    id: "input-filtro-simplificado"
                  },
                  model: {
                    value: _vm.filtro.campoSimples,
                    callback: function($$v) {
                      _vm.$set(_vm.filtro, "campoSimples", $$v)
                    },
                    expression: "filtro.campoSimples"
                  }
                },
                [
                  _c("el-button", {
                    staticClass: "color-default",
                    attrs: {
                      slot: "append",
                      icon: "el-icon-search",
                      id: "botao-filtro-simplificado"
                    },
                    on: { click: _vm.pesquisar },
                    slot: "append"
                  })
                ],
                1
              )
            ],
            1
          )
        ])
      : _vm._e(),
    !_vm.filtro.simples && !_vm.showPesquisaLote
      ? _c("div", { staticClass: "advancedSearch" }, [
          _c(
            "form",
            {
              on: {
                submit: function($event) {
                  $event.preventDefault()
                  return _vm.$emit("pesquisar", _vm.filtro)
                }
              }
            },
            [
              _c(
                "div",
                { staticClass: "panel" },
                [
                  _c(
                    "el-row",
                    { attrs: { gutter: 10 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { lg: 6, md: 12, sm: 24 } },
                        [
                          _c("p", { staticClass: "titulo" }, [
                            _vm._v("Processo:")
                          ]),
                          _c("el-input", {
                            directives: [
                              {
                                name: "mask",
                                rawName: "v-mask",
                                value: ["#########/####"],
                                expression: "['#########/####']"
                              }
                            ],
                            model: {
                              value: _vm.filtro.numeroProcesso,
                              callback: function($$v) {
                                _vm.$set(_vm.filtro, "numeroProcesso", $$v)
                              },
                              expression: "filtro.numeroProcesso"
                            }
                          })
                        ],
                        1
                      ),
                      _vm.showfiltrosInformacoes
                        ? _c(
                            "el-col",
                            { attrs: { lg: 6, md: 12, sm: 24 } },
                            [
                              _c("p", { staticClass: "titulo" }, [
                                _vm._v("Período de Solicitação:")
                              ]),
                              _c(
                                "el-date-picker",
                                _vm._b(
                                  {
                                    staticClass: "full-width input date",
                                    attrs: {
                                      type: "daterange",
                                      "start-placeholder": "Período inicial",
                                      "end-placeholder": "Período Final",
                                      format: "dd/MM/yyyy",
                                      name: "data"
                                    },
                                    model: {
                                      value: _vm.filtro.periodoSolicitacao,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.filtro,
                                          "periodoSolicitacao",
                                          $$v
                                        )
                                      },
                                      expression: "filtro.periodoSolicitacao"
                                    }
                                  },
                                  "el-date-picker",
                                  _vm.$attrs,
                                  false
                                )
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.showFiltroDataChegada
                        ? _c(
                            "el-col",
                            { attrs: { lg: 6, md: 12, sm: 24 } },
                            [
                              _c("p", { staticClass: "titulo" }, [
                                _vm._v("Período de Chegada:")
                              ]),
                              _c("el-date-picker", {
                                staticClass: "full-width input date",
                                attrs: {
                                  type: "daterange",
                                  "start-placeholder": "Período Inicial",
                                  "end-placeholder": "Período Final",
                                  format: "dd/MM/yyyy"
                                },
                                on: { change: _vm.formatarDatas },
                                model: {
                                  value: _vm.filtro.dataChegadaSetor,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.filtro,
                                      "dataChegadaSetor",
                                      $$v
                                    )
                                  },
                                  expression: "filtro.dataChegadaSetor"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.showFiltro("filtroResponsavel")
                        ? _c(
                            "el-col",
                            { attrs: { lg: 6, md: 12, sm: 24 } },
                            [
                              _c("p", { staticClass: "titulo" }, [
                                _vm._v("Responsável:")
                              ]),
                              _c(
                                "el-select",
                                {
                                  staticClass: "full-width",
                                  attrs: {
                                    placeholder: "Selecione",
                                    clearable: "clearable",
                                    filterable: "filterable",
                                    "no-match-text":
                                      "Responsável não encontrado"
                                  },
                                  on: {
                                    clear: function($event) {
                                      _vm.filtro.responsavel = null
                                    }
                                  },
                                  model: {
                                    value: _vm.filtro.responsavel,
                                    callback: function($$v) {
                                      _vm.$set(_vm.filtro, "responsavel", $$v)
                                    },
                                    expression: "filtro.responsavel"
                                  }
                                },
                                _vm._l(_vm.responsaveisComSemVinculo, function(
                                  responsavel
                                ) {
                                  return _c("el-option", {
                                    key: responsavel.id,
                                    attrs: {
                                      label: responsavel.nomeCargo,
                                      value: responsavel.id
                                    }
                                  })
                                }),
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.showFiltro("filtroBairro") && !_vm.isMa
                        ? _c(
                            "el-col",
                            { attrs: { lg: 6, md: 12, sm: 24 } },
                            [
                              _c("p", { staticClass: "titulo" }, [
                                _vm._v("Bairro:")
                              ]),
                              _c("el-input", {
                                model: {
                                  value: _vm.filtro.bairro,
                                  callback: function($$v) {
                                    _vm.$set(_vm.filtro, "bairro", $$v)
                                  },
                                  expression: "filtro.bairro"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.showFiltro("filtroCredenciado")
                        ? _c(
                            "el-col",
                            { attrs: { lg: 6, md: 12, sm: 24 } },
                            [
                              _c("p", { staticClass: "titulo" }, [
                                _vm._v("Credenciado:")
                              ]),
                              _c(
                                "el-select",
                                {
                                  staticClass: "full-width",
                                  attrs: {
                                    placeholder: "Selecione",
                                    clearable: "clearable",
                                    filterable: "filterable",
                                    "no-match-text":
                                      "Credenciado não encontrado"
                                  },
                                  on: {
                                    clear: function($event) {
                                      _vm.filtro.credenciado = null
                                    }
                                  },
                                  model: {
                                    value: _vm.filtro.credenciado,
                                    callback: function($$v) {
                                      _vm.$set(_vm.filtro, "credenciado", $$v)
                                    },
                                    expression: "filtro.credenciado"
                                  }
                                },
                                _vm._l(_vm.credenciados, function(credenciado) {
                                  return _c("el-option", {
                                    key:
                                      credenciado.codigo +
                                      " - " +
                                      credenciado.nome,
                                    attrs: {
                                      label: credenciado.nome,
                                      value: credenciado.codigo
                                    }
                                  })
                                }),
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.showFiltro("filtroCredenciadoVistoria")
                        ? _c(
                            "el-col",
                            { attrs: { lg: 6, md: 12, sm: 24 } },
                            [
                              _c("p", { staticClass: "titulo" }, [
                                _vm._v("Credenciado:")
                              ]),
                              _c(
                                "el-select",
                                {
                                  staticClass: "full-width",
                                  attrs: {
                                    placeholder: "Selecione",
                                    clearable: "clearable",
                                    filterable: "filterable",
                                    "no-match-text":
                                      "Credenciado não encontrado"
                                  },
                                  on: {
                                    clear: function($event) {
                                      _vm.filtro.credenciado = null
                                    }
                                  },
                                  model: {
                                    value: _vm.filtro.credenciado,
                                    callback: function($$v) {
                                      _vm.$set(_vm.filtro, "credenciado", $$v)
                                    },
                                    expression: "filtro.credenciado"
                                  }
                                },
                                _vm._l(_vm.credenciados, function(credenciado) {
                                  return _c("el-option", {
                                    key: credenciado,
                                    attrs: {
                                      label: credenciado,
                                      value: credenciado
                                    }
                                  })
                                }),
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.showFiltro("filtroCredenciadoGeo")
                        ? _c(
                            "el-col",
                            { attrs: { lg: 6, md: 12, sm: 24 } },
                            [
                              _c("p", { staticClass: "titulo" }, [
                                _vm._v("Credenciado:")
                              ]),
                              _c(
                                "el-select",
                                {
                                  staticClass: "full-width",
                                  attrs: {
                                    placeholder: "Selecione",
                                    clearable: "clearable",
                                    filterable: "filterable",
                                    "no-match-text":
                                      "Credenciado não encontrado"
                                  },
                                  on: {
                                    clear: function($event) {
                                      _vm.filtro.credenciado = null
                                    }
                                  },
                                  model: {
                                    value: _vm.filtro.credenciado,
                                    callback: function($$v) {
                                      _vm.$set(_vm.filtro, "credenciado", $$v)
                                    },
                                    expression: "filtro.credenciado"
                                  }
                                },
                                _vm._l(_vm.credenciados, function(credenciado) {
                                  return _c("el-option", {
                                    key:
                                      credenciado.codigo +
                                      " - " +
                                      credenciado.nome,
                                    attrs: {
                                      label: credenciado.nome,
                                      value: credenciado.codigo
                                    }
                                  })
                                }),
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.showFiltro("filtroVistoriador")
                        ? _c(
                            "el-col",
                            { attrs: { lg: 6, md: 12, sm: 24 } },
                            [
                              _c("p", { staticClass: "titulo" }, [
                                _vm._v("Credenciado:")
                              ]),
                              _c(
                                "el-select",
                                {
                                  staticClass: "full-width",
                                  attrs: {
                                    placeholder: "Selecione",
                                    clearable: "clearable"
                                  },
                                  on: {
                                    clear: function($event) {
                                      _vm.filtro.tipoCredenciado = null
                                    }
                                  },
                                  model: {
                                    value: _vm.filtro.tipoCredenciado,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.filtro,
                                        "tipoCredenciado",
                                        $$v
                                      )
                                    },
                                    expression: "filtro.tipoCredenciado"
                                  }
                                },
                                _vm._l(_vm.tipoCredenciado, function(tipo) {
                                  return _c("el-option", {
                                    key: tipo.codigo,
                                    attrs: {
                                      label: tipo.name,
                                      value: tipo.codigo
                                    }
                                  })
                                }),
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.showFiltro("filtroSituacaoTituloCertidao")
                        ? _c(
                            "el-col",
                            { attrs: { lg: 6, md: 12, sm: 24 } },
                            [
                              _c("p", { staticClass: "titulo" }, [
                                _vm._v("Situação:")
                              ]),
                              _c(
                                "el-select",
                                {
                                  staticClass: "full-width",
                                  attrs: {
                                    placeholder: "Selecione",
                                    clearable: "clearable"
                                  },
                                  model: {
                                    value: _vm.filtro.status,
                                    callback: function($$v) {
                                      _vm.$set(_vm.filtro, "status", $$v)
                                    },
                                    expression: "filtro.status"
                                  }
                                },
                                _vm._l(_vm.situacaoTituloCertidao, function(
                                  situacao
                                ) {
                                  return _c("el-option", {
                                    key: situacao.codigo,
                                    attrs: {
                                      label: situacao.nome,
                                      value: situacao.codigo
                                    }
                                  })
                                }),
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.showFiltro("filtroOS")
                        ? _c(
                            "el-col",
                            { attrs: { lg: 6, md: 12, sm: 24 } },
                            [
                              _c("p", { staticClass: "titulo" }, [
                                _vm._v("Ordem de Serviço:")
                              ]),
                              _c(
                                "el-select",
                                {
                                  staticClass: "full-width",
                                  attrs: {
                                    placeholder: "Selecione",
                                    clearable: "clearable",
                                    filterable: "filterable"
                                  },
                                  model: {
                                    value: _vm.filtro.numeroOs,
                                    callback: function($$v) {
                                      _vm.$set(_vm.filtro, "numeroOs", $$v)
                                    },
                                    expression: "filtro.numeroOs"
                                  }
                                },
                                _vm._l(_vm.ordemServicoList, function(
                                  ordemServico
                                ) {
                                  return _c("el-option", {
                                    key: ordemServico.id,
                                    attrs: {
                                      label: ordemServico.label,
                                      value: ordemServico.label
                                    }
                                  })
                                }),
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.showFiltro("filtroOrdemServico")
                        ? _c(
                            "el-col",
                            { attrs: { lg: 6, md: 12, sm: 24 } },
                            [
                              _c("p", { staticClass: "titulo" }, [
                                _vm._v("Ordem de Serviço:")
                              ]),
                              _c("el-input", {
                                model: {
                                  value: _vm.filtro.numeroOs,
                                  callback: function($$v) {
                                    _vm.$set(_vm.filtro, "numeroOs", $$v)
                                  },
                                  expression: "filtro.numeroOs"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.showFiltro("filtroFuncao")
                        ? _c(
                            "el-col",
                            { attrs: { lg: 6, md: 12, sm: 24 } },
                            [
                              _c("p", { staticClass: "titulo" }, [
                                _vm._v("Função:")
                              ]),
                              _c(
                                "el-select",
                                {
                                  staticClass: "full-width",
                                  attrs: {
                                    placeholder: "Selecione",
                                    clearable: "clearable"
                                  },
                                  model: {
                                    value: _vm.filtro.funcao,
                                    callback: function($$v) {
                                      _vm.$set(_vm.filtro, "funcao", $$v)
                                    },
                                    expression: "filtro.funcao"
                                  }
                                },
                                _vm._l(_vm.funcoes, function(funcao) {
                                  return _c("el-option", {
                                    key: funcao.codigo,
                                    attrs: {
                                      label: funcao.nome,
                                      value: funcao.codigo
                                    }
                                  })
                                }),
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "div",
                        [
                          _vm.showFiltro("filtroCpf") &&
                          !_vm.showfiltrosInformacoes &&
                          !_vm.showFiltroPublicacaoPortaria &&
                          !_vm.showFiltroPublicacao
                            ? _c(
                                "el-col",
                                { attrs: { lg: 6, md: 12, sm: 24 } },
                                [
                                  _c("p", { staticClass: "titulo" }, [
                                    _vm._v("CPF/CNPJ do Interessado:")
                                  ]),
                                  _c("el-input", {
                                    directives: [
                                      {
                                        name: "mask",
                                        rawName: "v-mask",
                                        value: [
                                          "###.###.###-##",
                                          "##.###.###/####-##"
                                        ],
                                        expression:
                                          "['###.###.###-##', '##.###.###/####-##']"
                                      }
                                    ],
                                    staticClass: "input input-with-select",
                                    model: {
                                      value: _vm.filtro.cpfCnpjInteressado,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.filtro,
                                          "cpfCnpjInteressado",
                                          $$v
                                        )
                                      },
                                      expression: "filtro.cpfCnpjInteressado"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.showfiltrosInformacoes
                            ? _c(
                                "el-col",
                                { attrs: { lg: 6, md: 12, sm: 24 } },
                                [
                                  _c("p", { staticClass: "titulo" }, [
                                    _vm._v("Setor de Origem:")
                                  ]),
                                  _c(
                                    "el-select",
                                    {
                                      staticClass: "full-width",
                                      attrs: {
                                        placeholder: "Selecione",
                                        clearable: "clearable"
                                      },
                                      model: {
                                        value: _vm.filtro.setorOrigem,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.filtro,
                                            "setorOrigem",
                                            $$v
                                          )
                                        },
                                        expression: "filtro.setorOrigem"
                                      }
                                    },
                                    _vm._l(_vm.setores, function(setor) {
                                      return _c("el-option", {
                                        key: setor.id,
                                        attrs: {
                                          label: setor.nome,
                                          value: setor.codigo
                                        }
                                      })
                                    }),
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.showFiltroSetor
                            ? _c(
                                "el-col",
                                { attrs: { lg: 6, md: 12, sm: 24 } },
                                [
                                  _c("p", { staticClass: "titulo" }, [
                                    _vm._v("Setor:")
                                  ]),
                                  _c(
                                    "el-select",
                                    {
                                      staticClass: "full-width",
                                      attrs: {
                                        placeholder: "Selecione",
                                        clearable: "clearable"
                                      },
                                      model: {
                                        value: _vm.filtro.setor,
                                        callback: function($$v) {
                                          _vm.$set(_vm.filtro, "setor", $$v)
                                        },
                                        expression: "filtro.setor"
                                      }
                                    },
                                    _vm._l(_vm.setores, function(setor) {
                                      return _c("el-option", {
                                        key: setor.id,
                                        attrs: {
                                          label: setor.nome,
                                          value: setor.codigo
                                        }
                                      })
                                    }),
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.showFiltro("filtroSituacaoTituloCertidao") &&
                          !_vm.isMa
                            ? _c(
                                "el-col",
                                { attrs: { lg: 6, md: 12, sm: 24 } },
                                [
                                  _c("p", { staticClass: "titulo" }, [
                                    _vm._v("Setor:")
                                  ]),
                                  _c(
                                    "el-select",
                                    {
                                      staticClass: "full-width",
                                      attrs: {
                                        placeholder: "Selecione",
                                        clearable: "clearable"
                                      },
                                      model: {
                                        value: _vm.filtro.setorProcesso,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.filtro,
                                            "setorProcesso",
                                            $$v
                                          )
                                        },
                                        expression: "filtro.setorProcesso"
                                      }
                                    },
                                    _vm._l(_vm.setoresTituloCertidao, function(
                                      codigo,
                                      setor
                                    ) {
                                      return _c("el-option", {
                                        key: setor,
                                        attrs: { label: codigo, value: setor }
                                      })
                                    }),
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          !_vm.showfiltrosInformacoes
                            ? _c(
                                "el-col",
                                { attrs: { lg: 6, md: 12, sm: 24 } },
                                [
                                  _c("p", { staticClass: "titulo" }, [
                                    _vm._v("Nome/Razão Social do Interessado:")
                                  ]),
                                  _c("el-input", {
                                    model: {
                                      value: _vm.filtro.nomeInteressado,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.filtro,
                                          "nomeInteressado",
                                          $$v
                                        )
                                      },
                                      expression: "filtro.nomeInteressado"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.showFiltro("filtroClausulaResolutiva")
                            ? _c(
                                "el-col",
                                { attrs: { lg: 6, md: 12, sm: 24 } },
                                [
                                  _c("p", { staticClass: "titulo" }, [
                                    _vm._v("Situação cláusula resolutiva:")
                                  ]),
                                  _c(
                                    "el-select",
                                    {
                                      staticClass: "full-width",
                                      attrs: {
                                        placeholder: "Selecione",
                                        clearable: "clearable"
                                      },
                                      model: {
                                        value:
                                          _vm.filtro.situacaoClausulaResolutiva,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.filtro,
                                            "situacaoClausulaResolutiva",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "filtro.situacaoClausulaResolutiva"
                                      }
                                    },
                                    _vm._l(
                                      _vm.situacaoClausulaResolutiva,
                                      function(tipo) {
                                        return _c("el-option", {
                                          key: tipo.codigo,
                                          attrs: {
                                            label: tipo.nome,
                                            value: tipo.codigo
                                          }
                                        })
                                      }
                                    ),
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.showFiltroPublicacaoPortaria
                            ? _c(
                                "el-col",
                                { attrs: { lg: 6, md: 12, sm: 24 } },
                                [
                                  _c("p", { staticClass: "titulo" }, [
                                    _vm._v("Número portaria:")
                                  ]),
                                  _c("el-input", {
                                    model: {
                                      value: _vm.filtro.numeroPortaria,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.filtro,
                                          "numeroPortaria",
                                          $$v
                                        )
                                      },
                                      expression: "filtro.numeroPortaria"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.showFiltroPublicacaoPortaria
                            ? _c(
                                "el-col",
                                { attrs: { lg: 6, md: 12, sm: 24 } },
                                [
                                  _c("p", { staticClass: "titulo" }, [
                                    _vm._v("Número publicação de portaria:")
                                  ]),
                                  _c("el-input", {
                                    model: {
                                      value:
                                        _vm.filtro.numeroPublicacaoPortaria,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.filtro,
                                          "numeroPublicacaoPortaria",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "filtro.numeroPublicacaoPortaria"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.showFiltroPublicacao
                            ? _c(
                                "el-col",
                                { attrs: { lg: 6, md: 12, sm: 24 } },
                                [
                                  _c("p", { staticClass: "titulo" }, [
                                    _vm._v("Número publicação:")
                                  ]),
                                  _c("el-input", {
                                    model: {
                                      value:
                                        _vm.filtro.numeroPublicacaoPortaria,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.filtro,
                                          "numeroPublicacaoPortaria",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "filtro.numeroPublicacaoPortaria"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.showFiltroPublicacaoPortaria ||
                          _vm.showFiltroPublicacao
                            ? _c(
                                "el-col",
                                { attrs: { lg: 6, md: 12, sm: 24 } },
                                [
                                  _c("p", { staticClass: "titulo" }, [
                                    _vm._v("Denominação do imóvel:")
                                  ]),
                                  _c("el-input", {
                                    model: {
                                      value: _vm.filtro.denominacao,
                                      callback: function($$v) {
                                        _vm.$set(_vm.filtro, "denominacao", $$v)
                                      },
                                      expression: "filtro.denominacao"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.showFiltroPublicacaoPortaria ||
                          _vm.showFiltroPublicacao
                            ? _c(
                                "el-col",
                                { attrs: { lg: 6, md: 12, sm: 24 } },
                                [
                                  _c("p", { staticClass: "titulo" }, [
                                    _vm._v("Período de publicação:")
                                  ]),
                                  _c(
                                    "el-date-picker",
                                    _vm._b(
                                      {
                                        staticClass: "full-width input date",
                                        attrs: {
                                          type: "daterange",
                                          "start-placeholder":
                                            "Período inicial",
                                          "end-placeholder": "Período Final",
                                          format: "dd/MM/yyyy",
                                          name: "data"
                                        },
                                        model: {
                                          value: _vm.filtro.periodoPublicacao,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.filtro,
                                              "periodoPublicacao",
                                              $$v
                                            )
                                          },
                                          expression: "filtro.periodoPublicacao"
                                        }
                                      },
                                      "el-date-picker",
                                      _vm.$attrs,
                                      false
                                    )
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _c("el-col", { attrs: { lg: 6, md: 12, sm: 24 } }, [
                            _c("p", { staticClass: "titulo" }, [
                              _vm._v("Tipo de processo:")
                            ]),
                            _vm.showFiltroTipoMultiplo
                              ? _c(
                                  "div",
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        staticClass: "full-width",
                                        attrs: {
                                          placeholder: "Selecione",
                                          multiple: "multiple",
                                          clearable: "clearable"
                                        },
                                        model: {
                                          value: _vm.filtro.tipos,
                                          callback: function($$v) {
                                            _vm.$set(_vm.filtro, "tipos", $$v)
                                          },
                                          expression: "filtro.tipos"
                                        }
                                      },
                                      _vm._l(_vm.tiposCadastroSelect, function(
                                        tipo
                                      ) {
                                        return _c("el-option", {
                                          key: tipo.codigo,
                                          attrs: {
                                            label: tipo.nome,
                                            value: tipo.codigo
                                          }
                                        })
                                      }),
                                      1
                                    )
                                  ],
                                  1
                                )
                              : _c(
                                  "div",
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        staticClass: "full-width",
                                        attrs: {
                                          placeholder: "Selecione",
                                          clearable: "clearable"
                                        },
                                        model: {
                                          value: _vm.filtro.tipo,
                                          callback: function($$v) {
                                            _vm.$set(_vm.filtro, "tipo", $$v)
                                          },
                                          expression: "filtro.tipo"
                                        }
                                      },
                                      _vm._l(_vm.tiposCadastroSelect, function(
                                        tipo
                                      ) {
                                        return _c("el-option", {
                                          key: tipo.codigo,
                                          attrs: {
                                            label: tipo.nome,
                                            value: tipo.codigo
                                          }
                                        })
                                      }),
                                      1
                                    )
                                  ],
                                  1
                                )
                          ]),
                          _vm.showFiltro("filtroSituacaoBoleto") || _vm.isCof
                            ? _c(
                                "el-col",
                                { attrs: { lg: 12, md: 12 } },
                                [
                                  _c("p", { staticClass: "titulo" }, [
                                    _vm._v("Situação:")
                                  ]),
                                  _c(
                                    "el-select",
                                    {
                                      staticClass: "full-width",
                                      attrs: {
                                        placeholder: "Selecione",
                                        clearable: "clearable"
                                      },
                                      model: {
                                        value: _vm.filtro.situacao,
                                        callback: function($$v) {
                                          _vm.$set(_vm.filtro, "situacao", $$v)
                                        },
                                        expression: "filtro.situacao"
                                      }
                                    },
                                    _vm._l(_vm.situacaoBoleto, function(
                                      situacao
                                    ) {
                                      return _c("el-option", {
                                        key: situacao.codigo,
                                        attrs: {
                                          label: situacao.nome,
                                          value: situacao.codigo
                                        }
                                      })
                                    }),
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.showFiltro("filtroTipoPagamento") ||
                          _vm.showFiltroTipoPagamentoCOF
                            ? _c(
                                "el-col",
                                { attrs: { lg: 6, md: 12, sm: 24 } },
                                [
                                  _c("p", { staticClass: "titulo" }, [
                                    _vm._v("Tipo de Pagamento:")
                                  ]),
                                  _c(
                                    "el-select",
                                    {
                                      staticClass: "full-width",
                                      attrs: {
                                        placeholder: "Selecione",
                                        clearable: "clearable"
                                      },
                                      model: {
                                        value: _vm.filtro.tipoPagamentoVtn,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.filtro,
                                            "tipoPagamentoVtn",
                                            $$v
                                          )
                                        },
                                        expression: "filtro.tipoPagamentoVtn"
                                      }
                                    },
                                    [
                                      _c("el-option", {
                                        key: "A_VISTA",
                                        attrs: {
                                          label: "À vista",
                                          value: "A_VISTA"
                                        }
                                      }),
                                      _c("el-option", {
                                        key: "PARCELADO",
                                        attrs: {
                                          label: "À prazo",
                                          value: "PARCELADO"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.showFiltro("filtroSituacao") &&
                          !_vm.showFiltro("isCPAV")
                            ? _c(
                                "el-col",
                                { attrs: { lg: 6, md: 12, sm: 24 } },
                                [
                                  _c("p", { staticClass: "titulo" }, [
                                    _vm._v("Situação:")
                                  ]),
                                  _c(
                                    "el-select",
                                    {
                                      staticClass: "full-width",
                                      attrs: {
                                        placeholder: "Selecione",
                                        clearable: "clearable"
                                      },
                                      model: {
                                        value: _vm.filtro.status,
                                        callback: function($$v) {
                                          _vm.$set(_vm.filtro, "status", $$v)
                                        },
                                        expression: "filtro.status"
                                      }
                                    },
                                    _vm._l(_vm.situacoes, function(situacao) {
                                      return _c("el-option", {
                                        key: situacao.codigo,
                                        attrs: {
                                          label: situacao.nome,
                                          value: situacao.codigo
                                        }
                                      })
                                    }),
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          !(
                            (_vm.isBa && _vm.caixa === "ASSINATURAS") ||
                            _vm.caixa === "EM_ANALISE_OS"
                          )
                            ? _c(
                                "el-col",
                                { attrs: { lg: 6, md: 12, sm: 24 } },
                                [
                                  _c("p", { staticClass: "titulo" }, [
                                    _vm._v("Município:")
                                  ]),
                                  _c(
                                    "el-select",
                                    {
                                      staticClass: "full-width",
                                      attrs: {
                                        multiple: "multiple",
                                        placeholder: "Selecione",
                                        clearable: "clearable",
                                        filterable: "filterable",
                                        "no-match-text":
                                          "Município não encontrado"
                                      },
                                      on: {
                                        clear: function($event) {
                                          _vm.filtro.municipio = null
                                        }
                                      },
                                      model: {
                                        value: _vm.filtro.municipio,
                                        callback: function($$v) {
                                          _vm.$set(_vm.filtro, "municipio", $$v)
                                        },
                                        expression: "filtro.municipio"
                                      }
                                    },
                                    _vm._l(_vm.municipios, function(m) {
                                      return _c("el-option", {
                                        key: m.id,
                                        attrs: { label: m.nome, value: m.id }
                                      })
                                    }),
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.showFiltro("filtroBairro") && _vm.isMa
                            ? _c(
                                "el-col",
                                { attrs: { lg: 6, md: 12, sm: 24 } },
                                [
                                  _c("p", { staticClass: "titulo" }, [
                                    _vm._v("Bairro:")
                                  ]),
                                  _c(
                                    "el-select",
                                    {
                                      staticClass: "full-width",
                                      attrs: {
                                        placeholder: "Selecione",
                                        clearable: "clearable",
                                        filterable: "filterable",
                                        multiple: "multiple",
                                        "no-match-text":
                                          "Bairro não encontrado",
                                        disabled:
                                          _vm.bairrosMunicipioSelecionado
                                            .length === 0
                                      },
                                      on: {
                                        clear: function($event) {
                                          _vm.filtro.bairro = null
                                        }
                                      },
                                      model: {
                                        value: _vm.filtro.bairros,
                                        callback: function($$v) {
                                          _vm.$set(_vm.filtro, "bairros", $$v)
                                        },
                                        expression: "filtro.bairros"
                                      }
                                    },
                                    _vm._l(
                                      _vm.bairrosMunicipioSelecionado,
                                      function(b) {
                                        return _c("el-option", {
                                          key: b.nome,
                                          attrs: {
                                            label: b.nome,
                                            value: b.nome
                                          }
                                        })
                                      }
                                    ),
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.showFiltro("filtroPerfil")
                            ? _c(
                                "el-col",
                                { attrs: { lg: 6, md: 12, sm: 24 } },
                                [
                                  _c("p", { staticClass: "titulo" }, [
                                    _vm._v("Perfil:")
                                  ]),
                                  _c(
                                    "el-select",
                                    {
                                      staticClass: "full-width",
                                      attrs: {
                                        placeholder: "Selecione",
                                        clearable: "clearable"
                                      },
                                      model: {
                                        value: _vm.filtro.perfilProcesso,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.filtro,
                                            "perfilProcesso",
                                            $$v
                                          )
                                        },
                                        expression: "filtro.perfilProcesso"
                                      }
                                    },
                                    _vm._l(_vm.perfisDJ, function(perfil) {
                                      return _c("el-option", {
                                        key: perfil.codigo,
                                        attrs: {
                                          label: perfil.nome,
                                          value: perfil.codigo
                                        }
                                      })
                                    }),
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.showFiltro("filtroCadastrante")
                            ? _c(
                                "el-col",
                                { attrs: { lg: 6, md: 12, sm: 24 } },
                                [
                                  _c("p", { staticClass: "titulo" }, [
                                    _vm._v("Executor:")
                                  ]),
                                  _c("el-input", {
                                    model: {
                                      value: _vm.filtro.nomeCadastrante,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.filtro,
                                          "nomeCadastrante",
                                          $$v
                                        )
                                      },
                                      expression: "filtro.nomeCadastrante"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.showfiltrosInformacoes
                            ? _c(
                                "el-col",
                                { attrs: { lg: 6, md: 12, sm: 24 } },
                                [
                                  _c("p", { staticClass: "titulo" }, [
                                    _vm._v("Status:")
                                  ]),
                                  _c(
                                    "el-select",
                                    {
                                      staticClass: "full-width",
                                      attrs: {
                                        placeholder: "Selecione",
                                        clearable: "clearable"
                                      },
                                      model: {
                                        value: _vm.filtro.status,
                                        callback: function($$v) {
                                          _vm.$set(_vm.filtro, "status", $$v)
                                        },
                                        expression: "filtro.status"
                                      }
                                    },
                                    _vm._l(_vm.statusSolicitacao, function(
                                      status
                                    ) {
                                      return _c("el-option", {
                                        key: status.codigo,
                                        attrs: {
                                          label: status.nome,
                                          value: status.codigo
                                        }
                                      })
                                    }),
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm.showFiltroDataEmissaoTitulo
                        ? _c(
                            "el-col",
                            { attrs: { lg: 6, md: 12, sm: 24 } },
                            [
                              _c("p", { staticClass: "titulo" }, [
                                _vm._v("Data de emissão do título:")
                              ]),
                              _c(
                                "el-date-picker",
                                _vm._b(
                                  {
                                    staticClass: "full-width input date",
                                    attrs: {
                                      type: "daterange",
                                      "start-placeholder": "Período inicial",
                                      "end-placeholder": "Período Final",
                                      format: "dd/MM/yyyy",
                                      name: "data"
                                    },
                                    model: {
                                      value: _vm.filtro.dataEmissaoTitulo,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.filtro,
                                          "dataEmissaoTitulo",
                                          $$v
                                        )
                                      },
                                      expression: "filtro.dataEmissaoTitulo"
                                    }
                                  },
                                  "el-date-picker",
                                  _vm.$attrs,
                                  false
                                )
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.showFiltro("filtroSituacaoAssinatura")
                        ? _c(
                            "el-col",
                            { attrs: { lg: 6, md: 12 } },
                            [
                              _c("p", { staticClass: "titulo" }, [
                                _vm._v("Situação:")
                              ]),
                              _c(
                                "el-select",
                                {
                                  staticClass: "full-width",
                                  attrs: {
                                    placeholder: "Selecione",
                                    clearable: "clearable"
                                  },
                                  model: {
                                    value: _vm.filtro.status,
                                    callback: function($$v) {
                                      _vm.$set(_vm.filtro, "status", $$v)
                                    },
                                    expression: "filtro.status"
                                  }
                                },
                                _vm._l(_vm.situacaoAssinaturaGabBA, function(
                                  situacao
                                ) {
                                  return _c("el-option", {
                                    key: situacao.codigo,
                                    attrs: {
                                      label: situacao.nome,
                                      value: situacao.codigo
                                    }
                                  })
                                }),
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.listaProcessosSelecionados
                        ? _c(
                            "div",
                            [
                              !_vm.showFiltroPublicacaoPortaria &&
                              !_vm.showFiltroPublicacao
                                ? _c(
                                    "el-col",
                                    {
                                      staticClass: "column-checkbox",
                                      attrs: { lg: 6, md: 12, sm: 24 }
                                    },
                                    [
                                      _c(
                                        "el-checkbox",
                                        {
                                          on: {
                                            change: function($event) {
                                              return _vm.setCheckboxProcessosSelecionados()
                                            }
                                          },
                                          model: {
                                            value:
                                              _vm.exibirProcessosSelecionados,
                                            callback: function($$v) {
                                              _vm.exibirProcessosSelecionados = $$v
                                            },
                                            expression:
                                              "exibirProcessosSelecionados"
                                          }
                                        },
                                        [
                                          _c(
                                            "label",
                                            { staticClass: "titulo" },
                                            [
                                              _vm._v(
                                                "Exibir apenas selecionados"
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.showFiltro("filtroStatusOrdemServico")
                                ? _c(
                                    "el-col",
                                    { attrs: { lg: 6, md: 12, sm: 24 } },
                                    [
                                      _c("p", { staticClass: "titulo" }, [
                                        _vm._v("Status da Ordem de Serviço:")
                                      ]),
                                      _c(
                                        "el-select",
                                        {
                                          staticClass: "full-width",
                                          attrs: {
                                            placeholder: "Selecione",
                                            clearable: "clearable"
                                          },
                                          model: {
                                            value: _vm.filtro.status,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.filtro,
                                                "status",
                                                $$v
                                              )
                                            },
                                            expression: "filtro.status"
                                          }
                                        },
                                        _vm._l(_vm.statusOs, function(status) {
                                          return _c("el-option", {
                                            key: status.codigo,
                                            attrs: {
                                              label: status.nome,
                                              value: status.codigo
                                            }
                                          })
                                        }),
                                        1
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.showFiltro("filtroTitulo")
                                ? _c(
                                    "el-col",
                                    { attrs: { lg: 6, md: 12, sm: 24 } },
                                    [
                                      _c("p", { staticClass: "titulo" }, [
                                        _vm._v("Título/Certidão:")
                                      ]),
                                      _c("el-input", {
                                        model: {
                                          value: _vm.filtro.numeroTitulo,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.filtro,
                                              "numeroTitulo",
                                              $$v
                                            )
                                          },
                                          expression: "filtro.numeroTitulo"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.showFiltro("filtroMunicipio")
                                ? _c(
                                    "el-col",
                                    { attrs: { lg: 6, md: 12 } },
                                    [
                                      _c("p", { staticClass: "titulo" }, [
                                        _vm._v("Município:")
                                      ]),
                                      _c(
                                        "el-select",
                                        {
                                          staticClass: "full-width",
                                          attrs: {
                                            multiple: "multiple",
                                            placeholder: "Selecione",
                                            clearable: "clearable",
                                            filterable: "filterable",
                                            "no-match-text":
                                              "Município não encontrado"
                                          },
                                          on: {
                                            clear: function($event) {
                                              _vm.filtro.municipio = null
                                            }
                                          },
                                          model: {
                                            value: _vm.filtro.municipio,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.filtro,
                                                "municipio",
                                                $$v
                                              )
                                            },
                                            expression: "filtro.municipio"
                                          }
                                        },
                                        _vm._l(_vm.municipios, function(m) {
                                          return _c("el-option", {
                                            key: m.id,
                                            attrs: {
                                              label: m.nome,
                                              value: m.id
                                            }
                                          })
                                        }),
                                        1
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.showFiltro("filtroReceita")
                                ? _c(
                                    "el-col",
                                    { attrs: { lg: 6, md: 12 } },
                                    [
                                      _c("p", { staticClass: "titulo" }, [
                                        _vm._v("Receita:")
                                      ]),
                                      _c(
                                        "el-select",
                                        {
                                          staticClass: "full-width",
                                          attrs: {
                                            placeholder: "Selecione",
                                            clearable: "clearable"
                                          },
                                          model: {
                                            value: _vm.filtro.receita,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.filtro,
                                                "receita",
                                                $$v
                                              )
                                            },
                                            expression: "filtro.receita"
                                          }
                                        },
                                        _vm._l(_vm.receitas, function(receita) {
                                          return _c("el-option", {
                                            key: receita.codigo,
                                            attrs: {
                                              label: receita.descricao,
                                              value: receita.id
                                            }
                                          })
                                        }),
                                        1
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.showFiltro("filtroSituacao") &&
                              _vm.showFiltro("isCPAV")
                                ? _c(
                                    "el-col",
                                    { attrs: { lg: 12, md: 12 } },
                                    [
                                      _c("p", { staticClass: "titulo" }, [
                                        _vm._v("Situação:")
                                      ]),
                                      _c(
                                        "el-select",
                                        {
                                          staticClass: "full-width",
                                          attrs: {
                                            placeholder: "Selecione",
                                            clearable: "clearable"
                                          },
                                          model: {
                                            value: _vm.filtro.status,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.filtro,
                                                "status",
                                                $$v
                                              )
                                            },
                                            expression: "filtro.status"
                                          }
                                        },
                                        _vm._l(_vm.situacoesCPAV, function(
                                          situacao
                                        ) {
                                          return _c("el-option", {
                                            key: situacao.codigo,
                                            attrs: {
                                              label: situacao.nome,
                                              value: situacao.codigo
                                            }
                                          })
                                        }),
                                        1
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.showFiltro("filtroSituacaoCertidao")
                                ? _c(
                                    "el-col",
                                    { attrs: { lg: 6, md: 12 } },
                                    [
                                      _c("p", { staticClass: "titulo" }, [
                                        _vm._v("Situação Certidão:")
                                      ]),
                                      _c(
                                        "el-select",
                                        {
                                          staticClass: "full-width",
                                          attrs: {
                                            placeholder: "Selecione",
                                            clearable: "clearable"
                                          },
                                          model: {
                                            value: _vm.filtro.situacaoCertidao,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.filtro,
                                                "situacaoCertidao",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "filtro.situacaoCertidao"
                                          }
                                        },
                                        _vm._l(_vm.situacoesCertidao, function(
                                          situacao
                                        ) {
                                          return _c("el-option", {
                                            key: situacao.codigo,
                                            attrs: {
                                              label: situacao.nome,
                                              value: situacao.codigo
                                            }
                                          })
                                        }),
                                        1
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.showFiltro("filtroDataVencimento")
                                ? _c(
                                    "el-col",
                                    { attrs: { lg: 6, md: 12 } },
                                    [
                                      _c("p", { staticClass: "titulo" }, [
                                        _vm._v("Data de Vencimento:")
                                      ]),
                                      _c(
                                        "el-date-picker",
                                        _vm._b(
                                          {
                                            staticClass:
                                              "full-width input date",
                                            attrs: {
                                              type: "daterange",
                                              "start-placeholder":
                                                "Data inicial",
                                              "end-placeholder": "Data Final",
                                              format: "dd/MM/yyyy",
                                              name: "data"
                                            },
                                            model: {
                                              value: _vm.filtro.dataVencimento,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.filtro,
                                                  "dataVencimento",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "filtro.dataVencimento"
                                            }
                                          },
                                          "el-date-picker",
                                          _vm.$attrs,
                                          false
                                        )
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.showFiltro("filtroArquivadosGac")
                                ? _c(
                                    "el-col",
                                    { attrs: { lg: 6, md: 12 } },
                                    [
                                      _c("p", { staticClass: "titulo" }, [
                                        _vm._v("Data de Arquivamento:")
                                      ]),
                                      _c(
                                        "el-date-picker",
                                        _vm._b(
                                          {
                                            staticClass:
                                              "full-width input date",
                                            attrs: {
                                              type: "daterange",
                                              "start-placeholder":
                                                "Data inicial",
                                              "end-placeholder": "Data Final",
                                              format: "dd/MM/yyyy",
                                              name: "data"
                                            },
                                            model: {
                                              value:
                                                _vm.filtro.dataArquivamento,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.filtro,
                                                  "dataArquivamento",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "filtro.dataArquivamento"
                                            }
                                          },
                                          "el-date-picker",
                                          _vm.$attrs,
                                          false
                                        )
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.showFiltro("filtroSituacaoBoleto")
                                ? _c(
                                    "el-col",
                                    { attrs: { lg: 6, md: 12, sm: 24 } },
                                    [
                                      _c("p", { staticClass: "titulo" }, [
                                        _vm._v("Situação:")
                                      ]),
                                      _c(
                                        "el-select",
                                        {
                                          staticClass: "full-width",
                                          attrs: {
                                            placeholder: "Selecione",
                                            clearable: "clearable"
                                          },
                                          model: {
                                            value: _vm.filtro.situacao,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.filtro,
                                                "situacao",
                                                $$v
                                              )
                                            },
                                            expression: "filtro.situacao"
                                          }
                                        },
                                        _vm._l(_vm.situacaoBoleto, function(
                                          situacao
                                        ) {
                                          return _c("el-option", {
                                            key: situacao.codigo,
                                            attrs: {
                                              label: situacao.nome,
                                              value: situacao.codigo
                                            }
                                          })
                                        }),
                                        1
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.showFiltro("filtroRua")
                                ? _c(
                                    "el-col",
                                    { attrs: { lg: 6, md: 12, sm: 24 } },
                                    [
                                      _c("p", { staticClass: "titulo" }, [
                                        _vm._v("Rua:")
                                      ]),
                                      _c("el-input", {
                                        model: {
                                          value: _vm.filtro.rua,
                                          callback: function($$v) {
                                            _vm.$set(_vm.filtro, "rua", $$v)
                                          },
                                          expression: "filtro.rua"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.showFiltro("filtroBairro")
                                ? _c(
                                    "el-col",
                                    { attrs: { lg: 6, md: 12, sm: 24 } },
                                    [
                                      _c("p", { staticClass: "titulo" }, [
                                        _vm._v("Bairro:")
                                      ]),
                                      _c("el-input", {
                                        model: {
                                          value: _vm.filtro.bairro,
                                          callback: function($$v) {
                                            _vm.$set(_vm.filtro, "bairro", $$v)
                                          },
                                          expression: "filtro.bairro"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.showFiltro("filtroRemessa")
                                ? _c(
                                    "el-col",
                                    { attrs: { lg: 6, md: 12, sm: 24 } },
                                    [
                                      _c("p", { staticClass: "titulo" }, [
                                        _vm._v("Remessa:")
                                      ]),
                                      _c("el-input", {
                                        model: {
                                          value: _vm.filtro.remessa,
                                          callback: function($$v) {
                                            _vm.$set(_vm.filtro, "remessa", $$v)
                                          },
                                          expression: "filtro.remessa"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.showFiltro("filtroQuadra")
                                ? _c(
                                    "el-col",
                                    { attrs: { lg: 6, md: 12, sm: 24 } },
                                    [
                                      _c("p", { staticClass: "titulo" }, [
                                        _vm._v("Quadra:")
                                      ]),
                                      _c("el-input", {
                                        model: {
                                          value: _vm.filtro.quadra,
                                          callback: function($$v) {
                                            _vm.$set(_vm.filtro, "quadra", $$v)
                                          },
                                          expression: "filtro.quadra"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.isMa
                        ? _c("button", {
                            staticStyle: { display: "none" },
                            attrs: { type: "submit" }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ]
          )
        ])
      : _vm._e(),
    _c("div", { staticClass: "button-group" }, [
      _c(
        "div",
        { staticClass: "left-buttons" },
        [
          _vm.showPesquisaAvancadaFiltro
            ? _c(
                "el-button",
                {
                  staticClass: "no-padding",
                  attrs: { type: "text" },
                  on: { click: _vm.changePesquisa }
                },
                [_vm._v(_vm._s(_vm.tituloPesquisa))]
              )
            : _vm._e(),
          _vm.showButtonPesquisaLote &&
          !_vm.showPesquisaLote &&
          _vm.isBa &&
          _vm.caixa === "ASSINATURA_CONJUNTA"
            ? _c(
                "el-button",
                {
                  staticClass: "no-padding",
                  attrs: { type: "text" },
                  on: { click: _vm.exibirBuscaPorLote }
                },
                [_vm._v("Pesquisa Lote")]
              )
            : _vm._e(),
          !_vm.showPesquisaLote
            ? _c(
                "el-button",
                {
                  staticClass: "no-padding",
                  attrs: { type: "text" },
                  on: { click: _vm.limpar }
                },
                [_vm._v("Limpar")]
              )
            : _vm._e()
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "right-buttons" },
        [
          !_vm.filtro.simples && !_vm.showPesquisaLote
            ? _c(
                "el-button",
                {
                  staticClass: "btn",
                  attrs: { type: "primary", id: "botao-filtro-avancado" },
                  on: { click: _vm.pesquisar }
                },
                [
                  _c("i", { staticClass: "el-icon-search" }),
                  _vm._v("  Pesquisar")
                ]
              )
            : _vm._e()
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7b7d992e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7b7d992e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/analise/listagem/Filtro.vue
// module id = null
// module chunks = 